import { ListPartnerNewsResponseSchema } from './list-partner-news.schema';
export const listPartnerNewsContract = {
    method: 'GET',
    path: '/api/v2/partner/news',
    description: 'List the published partner news',
    responseSchema: ListPartnerNewsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a partner tenant member'
        }
    }
};

//# sourceMappingURL=list-partner-news.contract.js.map